import { render, staticRenderFns } from "./FounderConsultDetail.vue?vue&type=template&id=bf47de12&"
import script from "./FounderConsultDetail.vue?vue&type=script&lang=ts&"
export * from "./FounderConsultDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports